import { render } from "./IntegratorsManagerView.vue?vue&type=template&id=57e5e24d"
import script from "./IntegratorsManagerView.vue?vue&type=script&lang=js"
export * from "./IntegratorsManagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__